// *****************  Push Notification Service Worker  ********************************
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService'

var config, publicVapidKey, service

(async () => {
  const response = await fetch(process.env.BASE_URL + 'config.json')
  config = await response.json()

  publicVapidKey = config.publicVapidKey || process.env.VUE_APP_publicVapidKey
  if (!publicVapidKey) {
    const impostazioni = await configurazioni.getConfigurazione('display_generale', 'webhook')
    publicVapidKey = _.get(impostazioni, 'notifichePush.publicVapidKey', '')
    console.log('VAPID KEYS da DB')
  }
  service = config.service_documenti || process.env.VUE_APP_service_documenti

  if ('serviceWorker' in navigator) {
    // TODO: Mettere la parte seguente solo se Documenti gestisce un database con le sottoscrizioni
    /*
    const result = await Notification.requestPermission()
    if (result === 'denied') {
      console.error('The user explicitly denied the permission request.')
      return
    }
    if (result === 'granted') {
      console.info('The user accepted the permission request.')
    }
    const registration = await navigator.serviceWorker.getRegistration()
    const subscribed = await registration.pushManager.getSubscription()
    if (subscribed) {
      console.info('User is already subscribed.')
      return
    }
    */
    console.log('push notification serviceWorker registered')
    registerServiceWorker().catch(console.log)
  }
})()

async function registerServiceWorker() {
  const registration = await navigator.serviceWorker.register('/pushNotificationServiceWorker.js', {
    scope: '/'
  })
  await registration.update()

  /*  const pushSubscription = await registration.pushManager.getSubscription()
  if (pushSubscription) {
    const json = pushSubscription.toJSON()
    console.log(json)
    const publicKey = json.keys.p256dh
    if (publicKey !== publicVapidKey) {
      console.log('Servizizo registrato con altra chiave. Effettuo unsubscribe', publicKey, publicVapidKey)
      // await pushSubscription.unsubscribe()
    }
  } */
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: publicVapidKey
  })

  await fetch(service + '/subscribe', {
    method: 'POST',
    body: JSON.stringify(subscription),
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
